var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCardText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5593_76131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7085 0.408203H2.7918C1.9168 0.408203 1.2168 1.16654 1.2168 2.04154V11.9582C1.2168 12.8332 1.9168 13.5915 2.85013 13.5915H12.7668C13.6418 13.5915 14.4001 12.8915 14.4001 11.9582V2.04154C14.2835 1.16654 13.5835 0.408203 12.7085 0.408203ZM7.28346 8.57487H2.03346V5.36654H7.28346V8.57487ZM8.2168 5.36654H13.4668V8.57487H8.2168V5.36654ZM2.7918 1.2832H12.7085C13.1168 1.2832 13.4085 1.6332 13.4085 1.9832V4.4332H2.03346V2.04154C2.03346 1.6332 2.38346 1.2832 2.7918 1.2832ZM2.03346 11.9582V9.5082H7.28346V12.7165H2.7918C2.38346 12.6582 2.03346 12.3665 2.03346 11.9582ZM12.7085 12.6582H8.15846V9.44987H13.4085V11.8999C13.4668 12.3665 13.1168 12.6582 12.7085 12.6582Z",
    fill: "#2362A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5593_76131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardText);
export default __webpack_public_path__ + "static/media/icon_card_text.3e06e4c0a12ca4fddca59d4866d304c3.svg";
export { ForwardRef as ReactComponent };